! function(e) {
    "use strict";
    e(document).ready(function() {
        e("#key-ingredients").length && e(".open-gallery-link").click(function() {
            var t = [];
            e(e(this).attr("href")).find(".slide").each(function() {
                t.push({
                    src: e(this)
                })
            }), e.magnificPopup.open({
                items: t,
                gallery: {
                    enabled: !0
                },
                callbacks: {
                    buildControls: function() {
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight))
                    }
                }
            })
        })
    })
}(jQuery);
var box, bb_announcements_flkty, bb_featured_products_flkty, bb_featured_collection_flkty, bb_testimonials_flkty, reviews_flkty, recipes_flkty, announcement_slider_options = {
        accessibility: !0,
        autoPlay: 6e3,
        pauseAutoPlayOnHover: !0,
        prevNextButtons: !1,
        pageDots: !1,
        cellAlign: "left"
    },
    bb_announcements_elem = document.querySelector(".notification-bar-slider");
if (bb_announcements_elem) var bb_announcements_flkty = new Flickity(bb_announcements_elem, announcement_slider_options);
var bb_featured_products_slider_options = {
    accessibility: !0,
    autoPlay: !1,
    prevNextButtons: !0,
    pageDots: !0,
    cellAlign: "left",
    imagesLoaded: !0,
    wrapAround: !0,
    contain: !0,
    draggable: !0,
    lazyLoad: !0,
    freeScroll: !0
};
matchMedia("screen and (max-width: 768px)").matches && (bb_featured_products_slider_options.prevNextButtons = !1), matchMedia("screen and (min-width: 1200px)").matches && (bb_featured_products_slider_options.pageDots = !1);
var bb_featured_products_elems = document.querySelectorAll(".bb-featured-products");
bb_featured_products_elems.forEach(e => {
    if (e) {
        var t, i = new Flickity(e, bb_featured_products_slider_options),
            s = e.querySelector(".indiv-product__image-wrapper");
        e.querySelectorAll(".flickity-button").forEach(function(e) {
           if(s){
                e.style.top = s.offsetHeight / 2 + "px";
            }            
        })
    }
});
var bb_featured_collection_slider_options = {
    accessibility: !0,
    autoPlay: !1,
    prevNextButtons: !0,
    pageDots: !1,
    cellAlign: "left",
    imagesLoaded: !0,
    wrapAround: !0,
    contain: !0,
    draggable: !0,
    lazyLoad: !0,
    freeScroll: !0
};
matchMedia("screen and (max-width: 768px)").matches && (bb_featured_collection_slider_options.prevNextButtons = !0), matchMedia("screen and (min-width: 1200px)").matches && (bb_featured_collection_slider_options.pageDots = !1);
var bb_featured_collection_elem = document.querySelector(".bb-featured-collection-slider");
if (bb_featured_collection_elem) var bb_featured_collection_flkty = new Flickity(bb_featured_collection_elem, bb_featured_collection_slider_options);
var bb_media_slider_options = {
    accessibility: !0,
    autoPlay: !1,
    prevNextButtons: !0,
    pageDots: !1,
    cellAlign: "left",
    imagesLoaded: !0,
    wrapAround: !0,
    contain: !0,
    draggable: !0,
    lazyLoad: !0,
    freeScroll: !0
};
var bb_featured_collection_flaour_slider = document.querySelector(".bb-featured-collection-flaour-slider");
if (bb_featured_collection_flaour_slider) var bb_featured_collection_flkty = new Flickity(bb_featured_collection_flaour_slider, bb_featured_collection_slider_options);
var bb_media_slider_options = {
    accessibility: !0,
    autoPlay: !1,
    prevNextButtons: !0,
    pageDots: !1,
    cellAlign: "left",
    imagesLoaded: !0,
    wrapAround: !0,
    contain: !0,
    draggable: !0,
    lazyLoad: !0,
    freeScroll: !0
};
matchMedia("screen and (max-width: 768px)").matches && (bb_media_slider_options.prevNextButtons = !0), matchMedia("screen and (min-width: 1200px)").matches && (bb_media_slider_options.pageDots = !1);

var bb_featured_collection_elem = document.querySelector(".bb-media-slider");
if (bb_featured_collection_elem) var bb_featured_collection_flkty = new Flickity(bb_featured_collection_elem, bb_media_slider_options);

var testimonial_slider_options = {
    accessibility: !0,
    autoPlay: !1,
    prevNextButtons: !0,
    pageDots: !0,
    cellAlign: "left",
    imagesLoaded: !0,
    wrapAround: !0,
    contain: !0,
    draggable: !0,
    lazyLoad: !0,
    freeScroll: !0
};
matchMedia("screen and (max-width: 768px)").matches && (testimonial_slider_options.prevNextButtons = !1), matchMedia("screen and (min-width: 1200px)").matches && (testimonial_slider_options.pageDots = !1);
var bb_testimonials_elem = document.querySelector(".bb-testimonial-slides");
if (bb_testimonials_elem) var bb_testimonials_flkty = new Flickity(bb_testimonials_elem, testimonial_slider_options);
var reviews_slider_options = {
    accessibility: !0,
    autoPlay: !1,
    prevNextButtons: !1,
    pageDots: !0,
    wrapAround: !0,
    contain: !0
};
matchMedia("screen and (max-width: 768px)").matches && (reviews_slider_options.pageDots = !0), matchMedia("screen and (min-width: 1200px)").matches;
var reviews_elem = document.querySelector(".reviews-gallery");
if (reviews_elem) {
    document.getElementById("product-reviews").getElementsByTagName("details")[0];
    var reviews_flkty = new Flickity(reviews_elem, reviews_slider_options)
}
var recipes_slider_options = {
    accessibility: !0,
    autoPlay: !1,
    prevNextButtons: !1,
    pageDots: !1,
    wrapAround: !0,
    imagesLoaded: !0,
    contain: !0
};
matchMedia("screen and (max-width: 768px)").matches, matchMedia("screen and (min-width: 1200px)").matches && (recipes_slider_options.prevNextButtons = !0);
var recipes_elem = document.querySelector(".recipes-gallery");
if (recipes_elem) {
    document.getElementById("product-iop").getElementsByTagName("details")[0];
    var recipes_flkty = new Flickity(recipes_elem, recipes_slider_options)
}

function stickyCartButton() {
    var e = document.getElementById("bb-atc-container");
    if (e) {
        var t = e.offsetTop;
        matchMedia("screen and (max-width: 766px)").matches && (t = 0), window.addEventListener("scroll", function i(s) {
            document.documentElement.scrollTop >= t ? e.classList.add("is-sticky") : e.classList.remove("is-sticky")
        })
    }
}
"complete" == document.readyState || "loaded" == document.readyState ? document.getElementById("bb-atc-container") && stickyCartButton() : window.addEventListener("DOMContentLoaded", stickyCartButton);